<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy"
             :fields="fields"
             :items="filteredItems"
             sticky-header
             responsive
             no-border-collapse
             show-empty
        >
            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay notificaciones que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha procesado ninguna notificación
                </b-card>
            </template>

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>
        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js'

export default {
    name: 'StatementNotificationAssignmentTable',

    components:{
        AlertDismiss
    },

    data() {
        return {
            isBusy: false,
            items: [],
            searchQuery: '',

            fields: [
                {
                    key: 'sent',
                    label: 'Enviado' ,
                    formatter: (value) => {
                        return value ? 'Si' : 'No'
                    }
                },
                { key: 'description', label: 'Descripción' },
                { key: 'templateName', label: 'Nombre de la plantilla' },
                { key: 'addresseeName', label: 'Nombre del destinatario' },
                { key: 'addresseeMail', label: 'Correo del destinatario' },
            ]
        }
    },

    async mounted(){
        this.$eventBus.$on(EventNames.FilterPepStatementsAfterSearch, (query) => {
            this.isBusy = true;

            this.searchQuery = query

            this.isBusy = false;
        });

        this.$eventBus.$on(EventNames.PaginationFilterPepAssignmentNotifications, async (query) => {
            this.isBusy = true;

            const page = query.page - 1; //se resta 1 por que el indice comienza en 0
            const pageSize = query.pageSize;

            await this.getAllAssignmentNotification(page, pageSize);

            this.isBusy = false;
        });
    },

    computed: {
        filteredItems() {
            let filtered = this.items;
            // Filtrar por búsqueda por nombre, apellido, etc.
            if (this.searchQuery) {
                filtered = this.filterForSearch(filtered, this.searchQuery)
            }

            return filtered;
        }
    },

    methods:{
        ...mapActions(["getAllPepStatementTemplateNotificationsByPage"]),

        filterForSearch(sendStatements, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            return sendStatements.filter(item =>
                Object.values(item).some(value =>
                    value.toString().toLowerCase().includes(normalizedQuery)
                )
            );
        },

        async getAllAssignmentNotification(page, pageSize){
            this.items = []

            const result = await this.getAllPepStatementTemplateNotificationsByPage({
                page: page,
                pageSize: pageSize
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            const notifications = result.data.map((notif) => {
                return {
                    id: notif.id,
                    sent: notif.sent,
                    description: notif.description,
                    templateName: notif.template.name,
                    addresseeName: notif.addressee.name,
                    addresseeMail: notif.addressee.mail
                };
            });

            this.items = notifications
        },
    }
}
</script>